import { render } from "./Header.vue?vue&type=template&id=24477935&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=24477935&scoped=true&lang=scss"

import exportComponent from "/Users/gigi/Documents/micowell/dalwa/xmai_official_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24477935"]])

export default __exports__